import { extractVideoId, checkIsYouTubeShorts, trackVideoAnalysis } from '../../utils';
import { AI_API_URL, API_BASE_URL } from '../../constants';

export const useYouTubeUtils = (setInputTitle, setLoading, setVideoDuration) => {
  
  // ✅ ISO8601 duration 파싱 함수
  const parseISO8601Duration = (duration) => {
    const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return 0;
    const hours = parseInt(match[1] || 0);
    const minutes = parseInt(match[2] || 0);
    const seconds = parseInt(match[3] || 0);
    return hours * 3600 + minutes * 60 + seconds;
  };

  // ✅ 백엔드를 통해 YouTube 제목 가져오기 함수 (보안 개선)
  const fetchYoutubeTitle = async (url) => {
    const extractedVideoId = extractVideoId(url);
    if (!extractedVideoId) {
      setInputTitle("");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/video-info/${extractedVideoId}`);
      const data = await response.json();
      
      if (data.success && data.data) {
        const videoInfo = data.data;
        const title = videoInfo.title;
        const durationSeconds = videoInfo.duration_seconds || 0;
        
        // 영상 길이 정보 설정
        setVideoDuration(durationSeconds);
        
        console.log(`[분석 시작] 영상: ${title}, 길이: ${durationSeconds}초 (${Math.round(durationSeconds/60)}분)`);
        
        // Google Analytics 이벤트 추적
        trackVideoAnalysis(url, title);
        
        // 쇼츠인 경우 제목에 표시 (URL 기반으로 먼저 체크)
        if (checkIsYouTubeShorts(url)) {
          setInputTitle(`📱 ${title} (쇼츠)`);
        } else {
          setInputTitle(title);
        }
      } else {
        setInputTitle("제목을 불러올 수 없음");
      }
    } catch (error) {
      console.warn("백엔드 YouTube API 호출 중 오류:", error);
      setInputTitle("제목을 불러올 수 없음");
    }
    setLoading(false);
  };

  return {
    parseISO8601Duration,
    fetchYoutubeTitle,
  };
}; 